var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{staticClass:"scroll-btn",attrs:{"small":"","tile":"","depressed":"","height":"50","light":"","color":"alabaster"}},[_c('VIcon',{staticClass:"arrow-down"},[_vm._v("mdi-arrow-down")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }